import React, { useState, useEffect, useCallback } from 'react';
import {
	Button,
	TextField,
	Select,
	MenuItem,
	InputLabel,
	FormControl,
	IconButton,
	Typography,
	Paper,
	Divider,
	Box,
	Switch,
	FormControlLabel,
	Container,
	Breadcrumbs,
	Link,
	Grid,
} from '@mui/material';
import {
	Close as CloseIcon,
	Add as AddIcon,
	ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { MennuTypeQuotation, SubCategoryQuotationprams } from '../../../services/api/quotation';
import { getAllMenus } from '../../../services/api/Menus';
// import { Quotation } from '../../../types/quotation';
import MenuSection from './MenuSection';
import RichTextEditor from './RichTextEditor';
import { createEvent, GetAllMenuTypes } from '../../../services/api/Event';
import MenuEventForm from '../eventtype/MenuEventForm';

interface MenuItem {
	item: string;
	quantity?: number;
	_id: string;
}

interface MenuType {
	datetime: string;
	discount: number;
	menuItems: {
		Items: string[];
	};
	menuType: string;
	numberOfPersons: number;
	perPerson: number;
	price: number;
	_id: string;
}

interface DefaultMenu {
	_id: string;
	name: string;
	price: number;
	menuItems: MenuType[];
	complementary: MenuItem[];
}

const QuotationPage = ({
	onClose,
	onSubmit,
	initialData,
	eventTypes,
	loader,
	setEventTypes,
	loadEventTypes,
}: any) => {
	const [isDefaultMenu, setIsDefaultMenu] = useState<boolean>(
		initialData?.isDefaultMenu || false
	);
	const [selectedQuotation, setSelectedQuotation] = useState<string | null>(null);
	const [menuDetails, setMenuDetails] = useState<any[]>([]);
	const [extraItems, setExtraItems] = useState<any[]>(
		initialData?.extraItems || [{ item: '', price: 0 }]
	);
	const [loaddiscoutn, setLoaddiscount] = useState<any | null>(null);
	const [menutypedata, setMenutypedata] = useState<any>('');
	const [menuTypes, setMenuTypes] = useState<string[]>([]);
	const [discount, setDiscount] = useState<number>(0);
	const [discountdefault, setDiscountdefault] = useState<number>(0);
	const [discountMenu, setDiscountMenu] = useState<number>(0);
	const [editAmount, setEditAmount] = useState<number>(0);
	const [subtotal, setSubtotal] = useState<number>(initialData?.subtotal || 0);
	console.log(subtotal, 'subtotal');

	const [gstPercentage, setGstPercentage] = useState<number>(initialData?.gstPercentage || 0);
	const [categories, setCategories] = useState<string[]>([]);
	const [subcategories, setSubcategories] = useState<string[]>([]);
	const [selectedCategory, setSelectedCategory] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const [availableDefaultMenus, setAvailableDefaultMenus] = useState<any[]>([]);
	const [finalAmountDiscounted, setFinalAmountDiscounted] = useState<number>();
	const [selectedDefaultMenu, setSelectedDefaultMenu] = useState<any | null>(
		initialData?.defaultMenuId || null
	);
	const [totalPriceAmount, setTotalPriceAmount] = useState<number>(0);
	console.log(totalPriceAmount, 'totalPriceAmount');

	const [discountAmount, setDiscountAmount] = useState<number>(0);
	const [hasPreviousDiscount, setHasPreviousDiscount] = useState<boolean>(false);

	const [formData, setFormData] = useState<{
		customerName: string;
		customerEmail: string;
		customerPhone: string;
		eventType: any;
		eventDate: string;
		eventLocation: string;
		complimentaryItems: { item: string; quantity: number; price: number }[];
		description: string;
		mandapaName: string;
		advancePayments: {
			paymentMethod?: string;
			date?: string;
			amount?: string;
			otherMethod?: string;
		}[];
	}>({
		customerName: '',
		customerEmail: '',
		customerPhone: '',
		eventType: '',
		eventDate: '',
		eventLocation: '',
		complimentaryItems: [],
		description: '',
		mandapaName: '',
		advancePayments: [{ paymentMethod: '', date: '', amount: '', otherMethod: '' }],
	});

	const [errors, setErrors] = useState({
		customerName: '',
		customerEmail: '',
		customerPhone: '',
		eventType: '',
		eventDate: '',
		eventLocation: '',
		menuDetails: '',
		discount: '',
		gstPercentage: '',
	});

	const [isDiscountApplied, setIsDiscountApplied] = useState<boolean>(false);
	const textFieldStyle = {
		minWidth: '211px',
		width: '100%',
		margin: 'normal',
	};
	const fetchMenuTypes = useCallback(async () => {
		setLoading(true);
		try {
			const response = await GetAllMenuTypes();
			const data = response?.data?.menuTypes;
			setMenuTypes(data || []);
		} catch (error) {
			// showSnackbar('Failed to fetch menu types', 'error');
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchMenuTypes();
	}, [fetchMenuTypes]);

	const initializeMenuDetails = () => {
		if (!initialData) return [];
		if (initialData.isDefaultMenu) {
			if (initialData?.menuTypes?.length === 0) {
				return initialData.defaultMenuId.menuTypes?.map((item: any) => ({
					...item,
					menuType: item.menuType,
					items: item.menuItems?.Items,
					perPerson: item.perPerson,
					totalPersons: item.numberOfPersons,
					datetime: item.datetime,
					discount: item.discount || 0,
				}));
			} else {
				return initialData.menuTypes?.map((item: any) => ({
					...item,
					menuType: item.menuType,
					items: item.menuItems?.Items,
					perPerson: item.perPerson,
					totalPersons: item.numberOfPersons,
					datetime: item.datetime,
					discount: item.discount || 0,
				}));
			}
		} else {
			return (
				initialData?.menuTypes?.map((item: any) => ({
					...item,
					menuType: item?.menuType || item.type,
					items: item?.menuItems?.Items || item.items || [],
					perPerson: item.perPerson,
					totalPersons: item.numberOfPersons || item.totalPersons || 0,
					datetime: item.datetime || '',
					discount: item.discount || 0,
				})) || [
					{
						type: menuTypes[0] || '',
						items: [],
						perPerson: 0,
						totalPersons: 0,
						datetime: '',
						discount: 0,
					},
				]
			);
		}
	};
	console.log(initialData?.advanceAmounts, 'initialData?.advanceAmounts');

	useEffect(() => {
		if (initialData) {
			setSelectedQuotation(
				initialData?.eventType?._id || initialData?.defaultMenuId?.eventType || ''
			);
			setIsDefaultMenu(initialData?.isDefaultMenu || false);
			setTotalPriceAmount(initialData.totalPrice);
			setMenuDetails(initializeMenuDetails());
			if (initialData?.defaultMenuId) {
				setMenutypedata(
					initialData.defaultMenuId.menuTypes.map((item: any) => item.menuType)
				);
			} else {
				setMenutypedata(initialData?.menuDetails?.map((item: any) => item?.type) || []);
			}
			setEditAmount(initialData?.additionalAmount || 0);
			setExtraItems(initialData?.extratEvents || [{ item: '', price: 0 }]);
			setDiscountdefault(initialData.discount || 0);
			// setDiscount(initialData.subTotalPrice)
			setSubtotal(initialData.subtotal || 0);
			setGstPercentage(initialData.gstPercentage || 0);
			setSelectedDefaultMenu(initialData.defaultMenuId || null);
			setLoaddiscount('');
			setFormData((prevFormData) => ({
				...prevFormData,
				customerName: prevFormData?.customerName
					? prevFormData?.customerName
					: initialData?.name,
				advancePayments: initialData?.advanceAmounts?.map((ite: any) => ({
					paymentMethod: ite.paymentMethod,
					date: new Date(ite.date).toISOString().split('T')[0],
					amount: ite.amount,
					otherMethod: ite.otherMethod,
				})) || [{ paymentMethod: '', date: '', amount: '', otherMethod: '' }],
				customerEmail: prevFormData?.customerEmail || initialData?.email,
				customerPhone: prevFormData?.customerPhone
					? prevFormData?.customerPhone
					: initialData?.mobile,
				eventType:
					prevFormData?.eventType?._id ||
					initialData?.defaultMenuId?.eventType ||
					initialData.eventType?._id,
				eventDate: prevFormData.eventDate
					? new Date(initialData.functionDate).toISOString().split('T')[0]
					: new Date().toISOString().split('T')[0],
				eventLocation: prevFormData.eventLocation
					? prevFormData.eventLocation.split(',')[0]
					: initialData.location.split(',')[0],
				complimentaryItems: prevFormData?.complimentaryItems
					? initialData?.menuTypes?.length === 0
						? initialData?.defaultMenuId?.complementary?.map((item: any) => ({
								item: item.item,
								quantity: item.quantity || 1,
								price: 0,
							}))
						: initialData.complementary?.map((item: any) => ({
								item: item.item,
								quantity: item.quantity || 1,
								price: 0,
							}))
					: initialData.complementary?.map((item: any) => ({
							item: item.item,
							quantity: item.quantity || 1,
							price: 0,
						})) || [{ item: '', quantity: 1, price: 0 }],
				description: prevFormData?.description
					? prevFormData?.description
					: initialData?.description,
				mandapaName: prevFormData?.mandapaName?.split(',')[1]?.trim()
					? prevFormData?.mandapaName?.split(',')[1]?.trim()
					: initialData?.location?.split(',')[1]?.trim(),
			}));
			if (initialData.isDefaultMenu && !initialData.defaultMenuId) {
				fetchDefaultMenus();
			}
		} else {
			setSelectedQuotation(formData?.eventType || '');
			setIsDefaultMenu(false);
			setMenuDetails([
				{
					menuType: menuTypes[0] || '',
					items: [],
					perPerson: 0,
					totalPersons: 0,
					datetime: '',
					discount: 0,
				},
			]);
			setDiscount(0);
			setSubtotal(0);
			setGstPercentage(0);
			setFormData({
				customerName: '',
				customerEmail: '',
				customerPhone: '',
				eventType: '',
				eventDate: new Date().toISOString().split('T')[0],
				eventLocation: '',
				complimentaryItems: [{ item: '', quantity: 1, price: 0 }],
				advancePayments: [{ paymentMethod: '', date: '', amount: '', otherMethod: '' }],
				description: '',
				mandapaName: '',
			});
		}
	}, [initialData]);

	useEffect(() => {
		console.log(selectedDefaultMenu, 'selectedDefaultMenu----------->');
		console.log(isDefaultMenu, 'isDefaultMenu----------->');
		const menuTotal =
			isDefaultMenu && selectedDefaultMenu
				? selectedDefaultMenu.price
				: menuDetails.reduce(
						(total, menu) =>
							total +
							menu.perPerson * menu.totalPersons -
							(loaddiscoutn ? menu.discount : 0),
						0
					);
		const extraItemsTotal = extraItems.reduce((total, item) => total + (item.price || 0), 0);
		setSubtotal(menuTotal + extraItemsTotal);

		// Set discount amount and check for previous values
		if (initialData?.discount) {
			setDiscountAmount(initialData.discount);
			setHasPreviousDiscount(true);
		} else {
			setDiscountAmount(0);
			setHasPreviousDiscount(false);
		}
	}, [
		menuDetails,
		extraItems,
		isDefaultMenu,
		selectedDefaultMenu,
		loaddiscoutn,
		initialData?.discount,
	]);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
		if (name === 'eventType') {
			setSelectedQuotation(value);
		}
	};

	const handleAddMenu = () => {
		if (menuDetails.length < menuTypes.length) {
			const availableMenuTypes = menuTypes.filter(
				(type) => !menuDetails.some((menu) => menu.menuType === type)
			);
			if (availableMenuTypes.length > 0) {
				setMenuDetails([
					...menuDetails,
					{
						menuType: availableMenuTypes[0],
						items: [],
						perPerson: 0,
						totalPersons: 0,
						datetime: '',
						discount: 0,
					},
				]);
			}
		}
	};

	const handleRemoveMenu = (index: number) => {
		setMenuDetails(menuDetails.filter((_, i) => i !== index));
	};

	const handleMenuChange = (index: number, updatedMenu: any) => {
		setMenuDetails(
			menuDetails.map((menu, i) => (i === index ? { ...menu, ...updatedMenu } : menu))
		);
	};

	const handleAddExtraItem = () => {
		setExtraItems([...extraItems, { item: '', price: 0 }]);
	};

	const handleRemoveExtraItem = (index: number) => {
		setExtraItems(extraItems.filter((_, i) => i !== index));
	};

	const handleExtraItemChange = (index: number, field: string, value: string) => {
		setExtraItems(
			extraItems.map((extra, i) => {
				if (i === index) {
					return {
						...extra,
						[field]: field === 'price' ? parseFloat(value) || 0 : value,
					};
				}
				return extra;
			})
		);
	};

	const handleAddComplimentaryItem = () => {
		setFormData({
			...formData,
			complimentaryItems: [
				...formData.complimentaryItems,
				{ item: '', quantity: 1, price: 0 },
			],
		});
	};

	const handleRemoveComplimentaryItem = (index: number) => {
		setFormData({
			...formData,
			complimentaryItems: formData.complimentaryItems.filter((_: any, i: any) => i !== index),
		});
	};

	const handleComplimentaryItemChange = (index: number, field: string, value: string) => {
		setFormData({
			...formData,
			complimentaryItems: formData.complimentaryItems.map((item: any, i: any) =>
				i === index
					? {
							...item,
							[field]:
								field === 'quantity'
									? parseInt(value) || 0
									: field === 'price'
										? parseFloat(value) || 0
										: value,
						}
					: item
			),
		});
	};

	const fetchAllCategories = async (selectedQuotation: string) => {
		setLoading(true);
		setError(null);
		try {
			const response = await MennuTypeQuotation(selectedQuotation);
			if (response.success) {
				setMenuTypes(response?.data?.menuTypeNames || []);
			}
			const categoriesData = response.data?.categories || response?.categories || [];
			const filteredCategories = categoriesData?.filter((category: any) =>
				category?.tag?.some((tag: string) => menutypedata?.includes(tag))
			);
			const catergoriesfilter = filteredCategories?.map((item: any) => item?.name);
			setCategories(catergoriesfilter);
		} catch (err) {
			console.error('Error fetching categories:', err);
			setError('Failed to load categories');
			setCategories([]);
		} finally {
			setLoading(false);
		}
	};

	const fetchSubcategories = async (selectedCategory: string) => {
		if (!selectedCategory) return;
		setLoading(true);
		setError(null);
		try {
			const response = await SubCategoryQuotationprams(selectedCategory);
			const subcategoriesData = response.data?.subcategories || response.subcategories || [];
			setSubcategories(subcategoriesData);
		} catch (err) {
			console.error('Error fetching subcategories:', err);
			setError('Failed to load subcategories');
			setSubcategories([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (formData.eventType) {
			fetchAllCategories(formData.eventType);
		} else {
			setCategories([]);
			setSubcategories([]);
		}
	}, [menutypedata, formData.eventType]);

	useEffect(() => {
		if (selectedCategory) {
			fetchSubcategories(selectedCategory);
		} else {
			setSubcategories([]);
		}
	}, [selectedCategory]);

	const validateForm = () => {
		let valid = true;
		const newErrors = {
			customerName: '',
			customerEmail: '',
			customerPhone: '',
			eventType: '',
			eventDate: '',
			eventLocation: '',
			menuDetails: '',
			extraItems: '',
			discount: '',
			gstPercentage: '',
			menuTypes: '',
		};
		if (!formData.customerName.trim()) {
			newErrors.customerName = 'Name is required';
			valid = false;
		}
		if (!formData.customerEmail.trim()) {
			newErrors.customerEmail = 'Email is required';
			valid = false;
		} else if (!/\S+@\S+\.\S+/.test(formData.customerEmail)) {
			newErrors.customerEmail = 'Invalid email format';
			valid = false;
		}
		if (!formData.customerPhone.trim()) {
			newErrors.customerPhone = 'Phone number is required';
			valid = false;
		} else if (!/^\d{10}$/.test(formData.customerPhone)) {
			newErrors.customerPhone = 'Invalid phone number format';
			valid = false;
		}
		if (!formData.eventType) {
			newErrors.eventType = 'Event type is required';
			valid = false;
		}
		if (!formData.eventDate) {
			newErrors.eventDate = 'Event date is required';
			valid = false;
		}
		if (!formData.eventLocation.trim()) {
			newErrors.eventLocation = 'Event location is required';
			valid = false;
		}
		if (isDefaultMenu) {
			menuDetails.forEach((menu, index) => {
				// if (menu?.items?.length === 0) {
				// 	newErrors.menuDetails = `Items are required for menu ${index + 1}`;
				// 	valid = false;
				// }
				if (!isDefaultMenu) {
					if (menu?.perPerson <= 0) {
						newErrors.menuDetails = `Per person price is required for menu ${index + 1}`;
						valid = false;
					}
				}
				if (menu.totalPersons <= 0) {
					newErrors.menuDetails = `Total persons is required for menu ${index + 1}`;
					valid = false;
				}
				if (!menu.datetime) {
					newErrors.menuDetails = `Datetime is required for menu ${index + 1}`;
					valid = false;
				}
			});
		}
		if (discount < 0) {
			newErrors.discount = 'Discount must be a positive number';
			valid = false;
		}
		if (gstPercentage < 0) {
			newErrors.gstPercentage = 'GST percentage must be a positive number';
			valid = false;
		}
		setErrors(newErrors);
		return valid;
	};

	const handleSubmit = () => {
		if (!validateForm()) {
			console.log(discountdefault, loading);
			return;
		}
		const menuTotal =
			isDefaultMenu && selectedDefaultMenu
				? selectedDefaultMenu.price
				: menuDetails.reduce(
						(total, menu) =>
							total +
							menu.perPerson * menu.totalPersons -
							(loaddiscoutn ? menu.discount : 0),
						0
					);
		const extraItemsTotal = extraItems.reduce((total, item) => total + (item.price || 0), 0);
		const finalAmount = discount;
		const roundToFive = (num: number) => Math.round(num * 1e5) / 1e5;
		console.log(discountAmount);

		const quotation = {
			name: formData.customerName,
			email: formData.customerEmail,
			mobile: formData.customerPhone,
			description: formData.description,
			eventType: formData.eventType,
			functionDate: formData.eventDate,

			location: `${formData.eventLocation}, ${formData?.mandapaName}`,
			menuTypes: menuDetails.map((menu) => {
				const originalAmount = menu.perPerson * menu.numberOfPersons;
				const totalMenuValue = menuDetails.reduce(
					(sum, m) => sum + m.perPerson * m.numberOfPersons,
					0
				);
				const menuShare = totalMenuValue > 0 ? originalAmount / totalMenuValue : 0;
				const itemDiscount = discount * menuShare;
				const discountedAmount = originalAmount - itemDiscount;
				const discountedPerPerson = discountedAmount / menu.numberOfPersons;
				const perPersonDiscount = menu.perPerson - discountedPerPerson;

				const perPerson = discount
					? Number.isFinite(perPersonDiscount)
						? perPersonDiscount.toFixed(5)
						: '0.00'
					: Number.isFinite(discountedPerPerson)
						? discountedPerPerson.toFixed(5)
						: '0.00';

				// const price = discount
				//     ? Number.isFinite(itemDiscount)
				//         ? itemDiscount.toFixed(5)
				//         : '0.00'
				//     : Number.isFinite(originalAmount)
				//         ? originalAmount.toFixed(5)
				//         : '0.00';
				const price = discount
					? Number.isFinite(itemDiscount)
						? Number(Number(itemDiscount.toFixed(5)))
						: 0
					: Number.isFinite(originalAmount)
						? Number(originalAmount.toFixed(5))
						: 0;

				return {
					...menu,
					perPerson,
					price,
				};
			}),

			...(discountAmount > 0
				? {
						previousMenuDiscount: isDiscountApplied
							? // Only add if the latest entry is different
								// discountAmount > discountAmount
								// ?
								[
									...initialData.previousMenuDiscount,
									{
										date: new Date().toISOString(),
										amount: discountAmount,
									},
								]
							: // : initialData.previousMenuDiscount
								[...initialData.previousMenuDiscount],
					}
				: {}),
			additionalAmount: editAmount,
			complementary: formData?.complimentaryItems
				.filter((item) => item.item)
				.map((item) => ({
					item: item.item,
					quantity: item.quantity,
					price: Math.round(item.price),
				})),
			extratEvents: extraItems
				.filter((item) => item.item && item.price > 0)
				.map((item) => ({
					...item,
					price: Math.round(item.price),
				})),
			menuTotal: Math.round(menuTotal),
			extraItemsTotal: Math.round(extraItemsTotal),
			subTotalPrice: discount
				? roundToFive(discount)
				: isDefaultMenu
					? (selectedDefaultMenu?.price ?? 0)
					: roundToFive(
							menuDetails.reduce((sum, m) => sum + m.perPerson * m.totalPersons, 0)
						),
			discount: discountAmount,
			gstPercentage: Math.round(gstPercentage),
			totalPrice: isDefaultMenu
				? discount
					? discount +
						(extraItems?.reduce((total, item) => total + (item.price || 0), 0) || 0) +
						(editAmount || 0)
					: selectedDefaultMenu?.price +
						(extraItems?.reduce((total, item) => total + (item.price || 0), 0) || 0) +
						(editAmount || 0)
				: (finalAmount ? Math.round(finalAmount) : Math.round(menuTotal)) + extraItemsTotal,
			isDefaultMenu,
			finalAmount: isDefaultMenu
				? discount
					? discount +
						(extraItems?.reduce((total, item) => total + (item.price || 0), 0) || 0) +
						(editAmount || 0)
					: selectedDefaultMenu?.price +
						(extraItems?.reduce((total, item) => total + (item.price || 0), 0) || 0) +
						(editAmount || 0)
				: (finalAmount ? Math.round(finalAmount) : Math.round(menuTotal)) + extraItemsTotal,

			defaultMenuId: isDefaultMenu ? selectedDefaultMenu?._id : undefined,
			masterquotationPdf: initialData?.masterquotationPdf || undefined,
			quotationPdf: initialData?.quotationPdf || undefined,
			updatedAt: initialData?.updatedAt || new Date().toISOString(),
			createdAt: initialData?.createdAt || new Date().toISOString(),
			status: initialData?.status || 'Pending',
			ifMasterquotationPdfGenrated: initialData && loader ? true : false,
			...(initialData ? { advanceAmounts: formData?.advancePayments } : {}),
		};

		// console.log('discount ', discount);
		onSubmit(quotation);
		console.log(quotation);
	};

	const fetchDefaultMenus = async () => {
		try {
			const response = await getAllMenus();
			if (response?.success) {
				setAvailableDefaultMenus(response.data.menus);
				if (initialData?.isDefaultMenu && initialData?.defaultMenuId) {
					const defaultMenu = response.data.menus.find(
						(menu: DefaultMenu) => menu._id === initialData.defaultMenuId
					);
					if (defaultMenu) {
						setSelectedDefaultMenu(defaultMenu);
					}
				}
			} else {
				setError('Failed to fetch default menus');
			}
		} catch (error) {
			console.error('Error fetching default menus:', error);
			setError('Failed to load default menus');
		}
	};

	useEffect(() => {
		if (isDefaultMenu) {
			fetchDefaultMenus();
		}
	}, [isDefaultMenu]);

	const handleDefaultMenuToggle = (checked: boolean) => {
		setIsDefaultMenu(checked);
		if (checked) {
			if (selectedDefaultMenu) {
				setMenuDetails(
					selectedDefaultMenu.menuTypes.map((item: any) => ({
						...item,
						type: item.menuType,
						items: item.menuItems.Items,
						perPerson: item.perPerson - discount,
						totalPersons: item.numberOfPersons,
						datetime: item.datetime,
						discount: item.discount || 0,
					}))
				);
				setFormData((prev) => ({
					...prev,
					complimentaryItems: selectedDefaultMenu.complementary.map((item: any) => ({
						item: item.item,
						quantity: item.quantity || 1,
						price: 0,
					})),
				}));
			}
		} else {
			if (initialData?.menuDetails) {
				setMenuDetails(
					initialData.menuTypes.map((item: any) => ({
						...item,
						menuType: item.menuType || item.type,
						Items: item.menuItems?.Items || item.items || [],
						perPerson: item.perPerson || 0,
						totalPersons: item.numberOfPersons || item.totalPersons || 0,
						datetime: item.datetime || '',
						discount: item.discount || 0,
					}))
				);
			} else {
				setMenuDetails([
					{
						type: menuTypes[0] || '',
						items: [],
						perPerson: 0,
						totalPersons: 0,
						datetime: '',
						discount: 0,
					},
				]);
			}
		}
	};

	const [openAddEventType, setOpenAddEventType] = useState(false);

	const handleAddEventType = async (data: any) => {
		try {
			const response = await createEvent(data);
			if (response.success) {
				setEventTypes((prevEventTypes: any) => [...prevEventTypes, response.data]);
				loadEventTypes();
				setOpenAddEventType(false);
			}
		} catch (error) {
			console.error('Error adding event type:', error);
		}
	};

	const menuTotal = menuDetails.reduce(
		(sum, m) => sum + (m.perPerson || 0) * (m.numberOfPersons || 0),
		0
	);

	const extraItemsTotal = extraItems.reduce((sum, item) => sum + (item.price || 0), 0);

	const overallTotal = menuTotal + extraItemsTotal;

	const handleApplyDiscount = () => {
		const safeFinalAmount =
			typeof finalAmountDiscounted === 'number' && !isNaN(finalAmountDiscounted)
				? finalAmountDiscounted
				: 0;
		console.log(menuTotal, '=========>menuTotal');
		console.log(safeFinalAmount, '=========>safeFinalAmount');
		const value = overallTotal - safeFinalAmount;
		const discountedMenuTotal = menuTotal - value;
		setDiscount(discountedMenuTotal);
		setDiscountAmount(value);
		setIsDiscountApplied(true);
	};

	const handleAdvancePaymentChange = (index: number, field: string, value: string) => {
		setFormData({
			...formData,
			advancePayments: formData.advancePayments.map((payment: any, i: any) =>
				i === index
					? {
							...payment,
							[field]: value,
						}
					: payment
			),
		});
	};

	const handleAddAdvancePayment = () => {
		setFormData({
			...formData,
			advancePayments: [
				...(formData.advancePayments || []),
				{ amount: '', date: '', paymentMethod: 'cash', otherMethod: '' },
			],
		});
	};

	const handleRemoveAdvancePayment = (index: number) => {
		setFormData({
			...formData,
			advancePayments: formData.advancePayments.filter((_: any, i: any) => i !== index),
		});
	};

	return (
		<Container maxWidth="lg" sx={{ py: 4 }}>
			<Box sx={{ mb: 3 }}>
				<Breadcrumbs aria-label="breadcrumb">
					<Link color="inherit" href="/quotation" underline="hover">
						Quotations
					</Link>
					<Typography color="text.primary">
						{initialData?.quotationId ? 'Edit Quotation' : 'Create Quotation'}
					</Typography>
				</Breadcrumbs>
				<Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
					<Button
						variant="outlined"
						startIcon={<ArrowBackIcon />}
						onClick={onClose}
						sx={{ ml: 2 }}
					>
						Back
					</Button>
				</Box>
			</Box>
			{error && (
				<Box display="flex" justifyContent="center" py={2}>
					<Typography color="error">{error}</Typography>
				</Box>
			)}
			<Grid container spacing={3}>
				<Grid item xs={12} md={8}>
					<Paper elevation={2} sx={{ p: 3, mb: 3 }}>
						<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
							Customer Information
						</Typography>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={4}>
								<TextField
									label="Name"
									name="customerName"
									value={formData.customerName}
									onChange={handleInputChange}
									size="small"
									fullWidth
									required
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<TextField
									label="Email"
									name="customerEmail"
									type="email"
									value={formData.customerEmail}
									onChange={handleInputChange}
									size="small"
									fullWidth
									required
									error={!!errors.customerEmail}
									helperText={errors.customerEmail}
								/>
							</Grid>
							<Grid item xs={12} sm={4}>
								<TextField
									label="Phone Number"
									name="customerPhone"
									value={formData.customerPhone}
									onChange={handleInputChange}
									size="small"
									fullWidth
									required
									error={!!errors.customerPhone}
									helperText={errors.customerPhone}
								/>
							</Grid>
						</Grid>
					</Paper>
					<Paper elevation={2} sx={{ p: 3, mb: 3 }}>
						<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
							Event Details
						</Typography>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<FormControl size="small" fullWidth>
									<InputLabel>Event Type</InputLabel>
									<Select
										value={formData.eventType}
										onChange={(e) => {
											setFormData({
												...formData,
												eventType: e.target.value as string,
											});
											setSelectedQuotation(e.target.value);
										}}
										label="Event Type"
										required
										error={!!errors?.eventType}
									>
										{eventTypes?.map((type: any) => (
											<MenuItem key={type._id} value={type._id}>
												{type.eventType}
											</MenuItem>
										))}
										<MenuItem onClick={() => setOpenAddEventType(true)}>
											<em>Add New Event Type</em>
										</MenuItem>
									</Select>
									{errors.eventType && (
										<Typography color="error" variant="caption">
											{errors.eventType}
										</Typography>
									)}
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Event Date"
									name="eventDate"
									type="date"
									InputLabelProps={{ shrink: true }}
									value={formData.eventDate}
									onChange={handleInputChange}
									size="small"
									fullWidth
									required
									error={!!errors.eventDate}
									helperText={errors.eventDate}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Mandapa Name"
									name="mandapaName"
									value={formData.mandapaName}
									onChange={handleInputChange}
									size="small"
									fullWidth
									required
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									label="Event Location"
									name="eventLocation"
									value={formData.eventLocation}
									onChange={handleInputChange}
									size="small"
									fullWidth
									required
									error={!!errors.eventLocation}
									helperText={errors.eventLocation}
								/>
							</Grid>
						</Grid>
					</Paper>
					<Paper elevation={2} sx={{ p: 3, mb: 3 }}>
						<Box display="flex" justifyContent="space-between" alignItems="center">
							<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
								Menu Details
							</Typography>
							<FormControlLabel
								control={
									<Switch
										checked={isDefaultMenu}
										onChange={(e) => handleDefaultMenuToggle(e.target.checked)}
										color="primary"
									/>
								}
								label={
									typeof isDefaultMenu === 'object'
										? JSON.stringify(isDefaultMenu)
										: typeof isDefaultMenu === 'boolean'
											? 'Use Default Menu'
											: JSON.stringify(isDefaultMenu)
								}
								labelPlacement="start"
							/>
						</Box>
						{!isDefaultMenu ? (
							<>
								{menuDetails?.map((menu, index) => (
									<React.Fragment key={index}>
										<MenuSection
											menu={menu}
											onChange={(updatedMenu: any) =>
												handleMenuChange(index, updatedMenu)
											}
											onRemove={() => handleRemoveMenu(index)}
											availableMenuTypes={menuTypes.filter(
												(type) =>
													type === menu?.type ||
													!menuDetails.some((m) => m?.type === type)
											)}
											categories={categories}
											subcategories={subcategories}
											setMenutypedata={setMenutypedata}
											setSelectedCategory={setSelectedCategory}
											selectedCategory={selectedCategory}
											isDefaultMenu={isDefaultMenu}
											setDiscountMenu={setDiscountMenu}
											discountMenu={discountMenu}
											selectedQuotation={selectedQuotation}
											menuTypes={menuTypes}
											loadEventTypes={loadEventTypes}
											fetchSubcategories={fetchSubcategories}
										/>
									</React.Fragment>
								))}
								{menuDetails.length < menuTypes.length && (
									<Button
										variant="outlined"
										startIcon={<AddIcon />}
										onClick={handleAddMenu}
										sx={{ mt: 2 }}
									>
										Add Another Menu
									</Button>
								)}
								{errors.menuDetails && (
									<Typography color="error" variant="caption">
										{errors.menuDetails}
									</Typography>
								)}
								<Box mt={3}>
									<Typography
										variant="h6"
										gutterBottom
										sx={{ fontWeight: 'bold' }}
									>
										Complimentary Items
									</Typography>
									{formData?.complimentaryItems?.map((item: any, index: any) => (
										<Box
											key={index}
											display="flex"
											alignItems="center"
											gap={2}
											mb={2}
										>
											<TextField
												label="Item Name"
												value={item.item}
												onChange={(e) =>
													handleComplimentaryItemChange(
														index,
														'item',
														e.target.value
													)
												}
												size="small"
												fullWidth
											/>
											<TextField
												label="Quantity"
												type="number"
												value={item.quantity}
												onChange={(e) =>
													handleComplimentaryItemChange(
														index,
														'quantity',
														e.target.value
													)
												}
												size="small"
											/>
											{formData.complimentaryItems.length > 1 && (
												<IconButton
													onClick={() =>
														handleRemoveComplimentaryItem(index)
													}
												>
													<CloseIcon />
												</IconButton>
											)}
										</Box>
									))}
									<Button
										variant="outlined"
										startIcon={<AddIcon />}
										onClick={handleAddComplimentaryItem}
									>
										Add Complimentary Item
									</Button>
								</Box>
							</>
						) : (
							<>
								<Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
									Select from available default menus:
								</Typography>
								<FormControl fullWidth size="small" sx={{ mt: 2, mb: 2 }}>
									<InputLabel>Default Menu Options</InputLabel>
									<Select
										value={selectedDefaultMenu?._id || ''}
										onChange={(e) => {
											const selected = availableDefaultMenus.find(
												(menu) => menu._id === e.target.value
											);
											setSelectedDefaultMenu(selected || null);
											if (selected) {
												setMenuDetails(
													selected.menuTypes?.map((item: any) => ({
														...item,
														menuType: item.menuType,
														Items: item?.menuItems?.Items,
														perPerson: item.perPerson,
														totalPersons: item.numberOfPersons,
														datetime: item.datetime,
														discount: item.discount || 0,
													}))
												);
												setFormData((prev) => ({
													...prev,
													complimentaryItems: selected.complementary.map(
														(item: any) => ({
															item: item.item,
															quantity: item.quantity || 1,
															price: 0,
														})
													),
												}));
											}
										}}
										label="Default Menu Options"
									>
										{availableDefaultMenus?.map((menu) => (
											<MenuItem key={menu?._id} value={menu?._id}>
												{menu?.name} - ₹{menu?.price?.toFixed(2)}
											</MenuItem>
										))}
									</Select>
								</FormControl>
								{selectedDefaultMenu && (
									<Box mt={2}>
										<Typography variant="subtitle2" color="textSecondary">
											Selected Menu: {selectedDefaultMenu?.name}
										</Typography>
										<Typography
											variant="body2"
											color="textSecondary"
											sx={{ mt: 1 }}
										>
											Price: ₹{selectedDefaultMenu?.price?.toFixed(2)}
										</Typography>
									</Box>
								)}
								{menuDetails?.map((menu, index) => (
									<React.Fragment key={index}>
										<MenuSection
											setDiscountMenu={setDiscountMenu}
											discountMenu={discountMenu}
											menu={menu}
											onChange={(updatedMenu: any) =>
												handleMenuChange(index, updatedMenu)
											}
											onRemove={() => handleRemoveMenu(index)}
											availableMenuTypes={menuTypes.filter(
												(type) =>
													type === menu?.menuType ||
													!menuDetails.some((m) => m?.menuType === type)
											)}
											categories={categories}
											subcategories={subcategories}
											setMenutypedata={setMenutypedata}
											setSelectedCategory={setSelectedCategory}
											selectedCategory={selectedCategory}
											isDefaultMenu={isDefaultMenu}
											loadEventTypes={loadEventTypes}
											selectedQuotation={selectedQuotation}
											menuTypes={menuTypes}
											fetchSubcategories={fetchSubcategories}
										/>
									</React.Fragment>
								))}
								<Box mt={3}>
									<Typography
										variant="h6"
										gutterBottom
										sx={{ fontWeight: 'bold' }}
									>
										Complimentary Items
									</Typography>
									{formData.complimentaryItems.map((item: any, index: any) => (
										<Box
											key={index}
											display="flex"
											alignItems="center"
											gap={2}
											mb={2}
										>
											<TextField
												label="Item Name"
												value={item.item}
												onChange={(e) =>
													handleComplimentaryItemChange(
														index,
														'item',
														e.target.value
													)
												}
												size="small"
												fullWidth
											/>
											<TextField
												label="Quantity"
												type="number"
												value={item.quantity}
												onChange={(e) =>
													handleComplimentaryItemChange(
														index,
														'quantity',
														e.target.value
													)
												}
												size="small"
											/>
											{formData.complimentaryItems.length > 1 && (
												<IconButton
													onClick={() =>
														handleRemoveComplimentaryItem(index)
													}
												>
													<CloseIcon />
												</IconButton>
											)}
										</Box>
									))}
									<Button
										variant="outlined"
										startIcon={<AddIcon />}
										onClick={handleAddComplimentaryItem}
									>
										Add Complimentary Item
									</Button>
								</Box>
							</>
						)}
					</Paper>
					<Paper elevation={2} sx={{ p: 3 }}>
						<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
							Extra Additions
						</Typography>

						{extraItems.map((extra, index) => (
							<Grid
								container
								key={index}
								spacing={2}
								alignItems="center"
								sx={{ mb: 1 }}
							>
								<Grid item xs={4}>
									<TextField
										label="Item Name"
										value={extra.item}
										onChange={(e) =>
											handleExtraItemChange(index, 'item', e.target.value)
										}
										size="small"
										fullWidth
									/>
								</Grid>
								<Grid item xs={4}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DemoContainer components={['DateTimePicker']}>
											<DateTimePicker
												label="Menu Date & Time"
												value={
													extra.datetime ? dayjs(extra.datetime) : null
												}
												onChange={(newValue) =>
													handleExtraItemChange(
														index,
														'datetime',
														newValue ? newValue.toISOString() : ''
													)
												}
												views={['year', 'day', 'hours', 'minutes']}
												format="DD/MM/YYYY hh:mm A"
												ampm={true}
												slotProps={{
													textField: {
														fullWidth: true,
														size: 'small',
														margin: 'normal',
														style: textFieldStyle,
													},
												}}
											/>
										</DemoContainer>
									</LocalizationProvider>
								</Grid>
								<Grid item xs={3}>
									<TextField
										label="Price"
										type="number"
										value={extra.price || ''}
										onChange={(e) =>
											handleExtraItemChange(index, 'price', e.target.value)
										}
										size="small"
										fullWidth
									/>
								</Grid>
								<Grid item xs={1}>
									{extraItems.length > 1 && (
										<IconButton onClick={() => handleRemoveExtraItem(index)}>
											<CloseIcon />
										</IconButton>
									)}
								</Grid>
							</Grid>
						))}

						<Button
							variant="outlined"
							startIcon={<AddIcon />}
							onClick={handleAddExtraItem}
						>
							Add Extra Item
						</Button>
					</Paper>
					<Paper elevation={2} sx={{ p: 4, mt: 4, mb: 6 }}>
						<RichTextEditor
							label="Description"
							name="description"
							value={
								formData.description
									? formData.description
									: initialData?.description
							}
							onChange={handleInputChange}
						/>
					</Paper>
				</Grid>
				<Grid item xs={12} md={4}>
					<Paper elevation={2} sx={{ p: 3, position: 'sticky', top: 16 }}>
						<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
							Price Summary
						</Typography>
						{!isDefaultMenu && (
							<Box mb={3}>
								<Typography
									variant="subtitle1"
									gutterBottom
									sx={{
										fontWeight: 'bold',
										color: 'primary.main',
										borderBottom: '1px solid',
										borderColor: 'divider',
										pb: 1,
										mb: 2,
									}}
								>
									Menu Breakdown
								</Typography>
								{menuDetails?.map((menu, index) => {
									const originalAmount = menu.perPerson * menu.numberOfPersons;
									const totalMenuValue = menuDetails.reduce(
										(sum, m) => sum + m.perPerson * m.numberOfPersons,
										0
									);
									const menuShare =
										totalMenuValue > 0 ? originalAmount / totalMenuValue : 0;
									const itemDiscount = discount * menuShare;
									const discountedAmount = originalAmount - itemDiscount;
									const discountedPerPerson =
										discountedAmount / menu.numberOfPersons;
									const perPersonDiscount = menu.perPerson - discountedPerPerson;

									return (
										<Paper
											key={index}
											elevation={0}
											sx={{
												mb: 2,
												p: 2,
												borderLeft: '4px solid',
												borderColor: 'primary.main',
												backgroundColor: 'background.paper',
												borderRadius: 1,
											}}
										>
											<Box
												display="flex"
												justifyContent="space-between"
												alignItems="flex-start"
											>
												<Box>
													<Typography
														variant="subtitle2"
														fontWeight="bold"
														color="text.primary"
													>
														{menu.type || menu.menuType}
													</Typography>

													{menu.datetime && (
														<Typography
															variant="body2"
															color="text.secondary"
															sx={{ mt: 0.5 }}
														>
															{dayjs(menu.datetime).format(
																'DD/MM/YYYY HH:mm'
															)}
														</Typography>
													)}

													<Box mt={1} mb={1}>
														<Typography
															variant="body2"
															color="text.secondary"
														>
															<Box
																component="span"
																sx={{
																	fontWeight: 'medium',
																	color: 'success.main',
																}}
															>
																₹{' '}
																{discount
																	? Number.isFinite(
																			perPersonDiscount
																		)
																		? perPersonDiscount.toFixed(
																				2
																			)
																		: '0.00'
																	: Number.isFinite(
																				discountedPerPerson
																		  )
																		? discountedPerPerson.toFixed(
																				2
																			)
																		: '0.00'}
																/person
															</Box>
															{discount > 0 && (
																<div>
																	{' ('}
																	<Box
																		component="span"
																		sx={{ color: 'error.main' }}
																	>
																		₹ -
																		{discountedPerPerson.toFixed(
																			2
																		)}{' '}
																	</Box>
																	{')'}
																</div>
															)}
														</Typography>
													</Box>

													<Typography
														variant="body2"
														color="text.secondary"
													>
														<Box
															component="span"
															sx={{ fontWeight: 'medium' }}
														>
															{menu.numberOfPersons || 0} persons
														</Box>
													</Typography>
												</Box>

												<Box
													display="flex"
													flexDirection="column"
													alignItems="flex-end"
												>
													{discount > 0 && (
														<Typography
															variant="body2"
															color="text.secondary"
															sx={{ textDecoration: 'line-through' }}
														>
															₹ {originalAmount.toFixed(2)}
														</Typography>
													)}

													<Typography
														variant="h6"
														fontWeight="bold"
														color="primary.main"
													>
														₹
														{discount
															? Number.isFinite(itemDiscount)
																? itemDiscount.toFixed(2)
																: '0.00'
															: Number.isFinite(originalAmount)
																? originalAmount.toFixed(2)
																: '0.00'}
													</Typography>
													{discount > 0 && (
														<Typography
															variant="caption"
															color="text.secondary"
														>
															Discount: ₹{discountedAmount.toFixed(2)}
														</Typography>
													)}
												</Box>
											</Box>
										</Paper>
									);
								})}
							</Box>
						)}
						{isDefaultMenu && (
							<Box
								display="flex"
								justifyContent="space-between"
								alignItems="center"
								mb={2}
							>
								<Typography color="textSecondary">Adjustment Amount :</Typography>
								<TextField
									// label={'Amount'}
									placeholder="0"
									type="number"
									value={editAmount || ''}
									onChange={(e) => setEditAmount(parseFloat(e.target.value) || 0)}
									size="small"
									sx={{ width: '120px' }}
								/>
							</Box>
						)}
						<Divider sx={{ my: 2 }} />
						{discount > 0 && (
							<Box
								display="flex"
								justifyContent="space-between"
								alignItems="center"
								mb={2}
							>
								<Typography
									variant="subtitle2"
									fontWeight="bold"
									color="text.primary"
								>
									Previous Menu Total:
								</Typography>
								<Typography
									fontWeight="bold"
									color="text.secondary"
									sx={{
										textDecoration: 'line-through',
										textDecorationThickness: '2px',
									}}
								>
									₹
									{isDefaultMenu
										? selectedDefaultMenu?.price
										: menuDetails
												.reduce(
													(sum, m) => sum + m.perPerson * m.totalPersons,
													0
												)
												.toFixed(2)}
								</Typography>
							</Box>
						)}
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							mb={2}
						>
							<Typography variant="subtitle2" fontWeight="bold" color="text.primary">
								Menu Total:
							</Typography>
							<Typography fontWeight="bold" color="primary.main">
								₹
								{discount
									? discount.toFixed(2)
									: isDefaultMenu
										? selectedDefaultMenu?.price
										: menuDetails
												.reduce(
													(sum, m) => sum + m.perPerson * m.totalPersons,
													0
												)
												.toFixed(2)}
							</Typography>
						</Box>
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							mb={2}
						>
							<Typography variant="subtitle2" fontWeight="bold" color="text.primary">
								Extra Items:
							</Typography>
							<Typography fontWeight="bold" color="primary.main">
								₹
								{extraItems
									.reduce((sum, item) => sum + (item.price || 0), 0)
									.toFixed(2)}
							</Typography>
						</Box>

						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							mb={2}
						>
							<Typography variant="subtitle2" fontWeight="bold" color="text.primary">
								Total:{' '}
							</Typography>
							<Typography fontWeight="bold" color="primary.main">
								₹
								{Number.isFinite(
									(discount
										? discount
										: isDefaultMenu
											? selectedDefaultMenu?.price
											: menuDetails.reduce(
													(sum, m) =>
														sum +
														(m.perPerson || 0) *
															(m.numberOfPersons || 0),
													0
												)) +
										extraItems.reduce((sum, item) => sum + (item.price || 0), 0)
								)
									? (
											(discount
												? discount
												: isDefaultMenu
													? selectedDefaultMenu?.price + editAmount
													: menuDetails.reduce(
															(sum, m) =>
																sum +
																(m.perPerson || 0) *
																	(m.numberOfPersons || 0),
															0
														)) +
											extraItems.reduce(
												(sum, item) => sum + (item.price || 0),
												0
											)
										).toFixed(2)
									: '0.00'}
							</Typography>
						</Box>

						{!isDefaultMenu && (
							<>
								{' '}
								<Paper
									elevation={0}
									sx={{
										mt: 2,
										p: 2,
										backgroundColor: 'action.hover',
										borderRadius: 1,
									}}
								>
									<Box
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Typography variant="subtitle2" fontWeight="bold">
											{hasPreviousDiscount
												? 'Previous Discounted Amount is:'
												: 'Total Menu Discount Applied:'}
										</Typography>
										<Typography
											variant="subtitle2"
											fontWeight="bold"
											color="error.main"
										>
											₹
											{hasPreviousDiscount
												? discountAmount.toFixed(2)
												: discountAmount.toFixed(2)}
										</Typography>
									</Box>
								</Paper>
								<Divider sx={{ my: 2 }} />
								<Box
									mt={2}
									display="flex"
									justifyContent="space-between"
									alignItems="center"
									fontWeight="bold"
									fontSize="1.125rem"
								>
									<TextField
										label="Final Amount"
										type="text"
										value={finalAmountDiscounted}
										onChange={(e) => {
											const value = e.target.value;
											const numericValue = value.replace(/[^0-9]/g, '');
											setFinalAmountDiscounted(
												numericValue === ''
													? undefined
													: Number(numericValue)
											);
											setIsDiscountApplied(false);
										}}
										size="small"
										sx={{ width: '120px' }}
										error={!!errors?.discount}
										helperText={errors?.discount}
										slotProps={{
											input: {
												inputMode: 'numeric',
												onKeyDown: (e) => {
													// Prevent non-numeric input
													if (['e', 'E', '+', '-'].includes(e.key)) {
														e.preventDefault();
													}
												},
											},
										}}
									/>
									<Button
										variant="contained"
										onClick={handleApplyDiscount}
										color="primary"
										sx={{ mr: 2 }}
										disabled={isDiscountApplied}
									>
										Apply Discount
									</Button>
								</Box>{' '}
							</>
						)}

						{initialData && (
							<Box mt={2}>
								<Typography
									variant="subtitle1"
									gutterBottom
									sx={{
										fontWeight: 'bold',
										color: 'primary.main',
										borderBottom: '1px solid',
										borderColor: 'divider',
										pb: 1,
										mb: 2,
									}}
								>
									Advance Amount
								</Typography>
								{formData?.advancePayments?.map((payment: any, index: any) => (
									<Box key={index} mb={2} flexDirection="row">
										<Box
											display="flex"
											sx={{
												justifyContent: 'space-between',
												alignItems: 'center',
											}}
										>
											<Typography variant="subtitle1" fontWeight="bold">
												Advance Payments {`(${index + 1})`}
											</Typography>

											{formData.advancePayments.length > 1 && (
												<IconButton
													onClick={() =>
														handleRemoveAdvancePayment(index)
													}
												>
													<DeleteOutlinedIcon />
												</IconButton>
											)}
										</Box>
										<Box
											sx={{
												mt: 1,
												display: 'flex',
												// gap: 2,
												justifyContent: 'space-between',
												alignItems: 'center',
											}}
										>
											<Typography
												variant="subtitle2"
												fontWeight="bold"
												color="text.primary"
											>
												Amount:{' '}
											</Typography>
											<TextField
												size="small"
												label="Amount"
												type="number"
												// fullWidth
												value={payment.amount}
												onChange={(e) =>
													handleAdvancePaymentChange(
														index,
														'amount',
														e.target.value
													)
												}
												sx={{ width: '200px' }}
											/>{' '}
										</Box>
										<Box
											sx={{
												mt: 1,
												display: 'flex',
												// gap: 5,

												alignItems: 'center',
												justifyContent: 'space-between',
											}}
										>
											<Typography
												variant="subtitle2"
												fontWeight="bold"
												color="text.primary"
											>
												Date:{' '}
											</Typography>
											<TextField
												label="Date"
												size="small"
												type="date"
												// fullWidth
												InputLabelProps={{ shrink: true }}
												value={payment.date}
												onChange={(e) =>
													handleAdvancePaymentChange(
														index,
														'date',
														e.target.value
													)
												}
												sx={{ width: '200px' }}
											/>
										</Box>
										<Box
											sx={{
												mt: 1,
												display: 'flex',
												// gap: 2,
												justifyContent: 'space-between',
												alignItems: 'center',
											}}
										>
											<Typography
												variant="subtitle2"
												fontWeight="bold"
												color="text.primary"
											>
												Payment Mode:{' '}
											</Typography>
											{/* <FormControl
												fullWidth
												size="small"
												sx={{ width: '200px' }}
											>
												<InputLabel>Payment Mode</InputLabel>
												<Select
													id="paymentMethod"
													value={payment.paymentMethod}
													onChange={(e) =>
														handleAdvancePaymentChange(
															index,
															'paymentMethod',
															e.target.value as string
														)
													}
													label="Payment Mode"
												>
													<MenuItem value="cash">Cash</MenuItem>
													<MenuItem value="card">Card</MenuItem>
													<MenuItem value="upi">UPI</MenuItem>
													<MenuItem value="netBanking">
														Net Banking
													</MenuItem>
													<MenuItem value="others">Others</MenuItem>
													{payment.paymentMethod === 'self' && (
														<MenuItem disableRipple disableGutters>
															<TextField
																autoFocus
																id="paymentMethod"
																placeholder="Enter Payment Method"
																size="small"
																value={
																	payment.selfPaymentMethod || ''
																}
																onChange={(e) =>
																	handleAdvancePaymentChange(
																		index,
																		'paymentMethod',
																		e.target.value
																	)
																}
																onClick={(e) => e.stopPropagation()}
																fullWidth
															/>
														</MenuItem>
													)}
												</Select>
											</FormControl> */}

											<FormControl
												fullWidth
												size="small"
												sx={{ width: '200px' }}
											>
												<InputLabel>Payment Mode</InputLabel>
												<Select
													id="paymentMethod"
													value={
														[
															'cash',
															'card',
															'upi',
															'netBanking',
														].includes(payment.paymentMethod)
															? payment.paymentMethod
															: 'others'
													}
													onChange={(e) => {
														const value = e.target.value;
														handleAdvancePaymentChange(
															index,
															'paymentMethod',
															value || ''
														);
													}}
													label="Payment Mode"
												>
													<MenuItem value="cash">Cash</MenuItem>
													<MenuItem value="card">Card</MenuItem>
													<MenuItem value="upi">UPI</MenuItem>
													<MenuItem value="netBanking">
														Net Banking
													</MenuItem>
													<MenuItem value="others">Others</MenuItem>
												</Select>

												{/* Show text input only if custom method is selected */}
												{!['cash', 'card', 'upi', 'netBanking'].includes(
													payment.paymentMethod
												) && (
													<TextField
														autoFocus
														id="otherMethod"
														placeholder="Enter Payment Method"
														size="small"
														value={payment.otherMethod}
														onChange={(e) =>
															handleAdvancePaymentChange(
																index,
																'otherMethod',
																e.target.value
															)
														}
														sx={{ mt: 1 }}
														fullWidth
													/>
												)}
											</FormControl>
										</Box>
									</Box>
								))}
								<Button
									variant="outlined"
									fullWidth
									startIcon={<AddIcon />}
									onClick={handleAddAdvancePayment}
								>
									Add Advance Payment
								</Button>
							</Box>
						)}
						<Box mt={4} display="flex" justifyContent="flex-end">
							<Button onClick={onClose} variant="outlined" sx={{ mr: 2 }}>
								Cancel
							</Button>
							<Button
								variant="contained"
								onClick={handleSubmit}
								color="primary"
								disabled={loader}
							>
								{loader
									? 'Processing...'
									: `${initialData?.quotationId ? 'Update' : 'Generate'} Quotation`}
							</Button>
						</Box>
					</Paper>
				</Grid>
			</Grid>
			<MenuEventForm
				currentItem="EventType"
				menuTypes={menuTypes}
				onSubmit={handleAddEventType}
				activeTab={1}
				open={openAddEventType}
				isEditing={false}
				onClose={() => setOpenAddEventType(false)}
			/>
		</Container>
	);
};

export default QuotationPage;
